export default class FinancialReport {
  static exec() {
    const els = document.querySelectorAll(
      '[data-component="financial-report"]'
    );
    els.forEach(function (el) {
      new FinancialReport(el);
    });
  }

  el;
  state = false;

  constructor(element) {
    const self = this;
    this.el = element;

    // URLパラメータから年度を取得して初期表示を設定
    this.initFromUrlParams();

    const tab_el = this.el.querySelectorAll(['[data-el="tab"]']);
    tab_el.forEach(function (el) {
      el.addEventListener('click', function () {
        if (el.dataset.state == 'close') {
          self.el
            .querySelectorAll(['[data-state="open"]'])
            .forEach(function (el) {
              el.dataset.state = 'close';
            });
          self.el
            .querySelectorAll(['[data-year="' + el.dataset.year + '"]'])
            .forEach(function (el) {
              el.dataset.state = 'open';
            });

          // URLパラメータを更新
          self.updateUrlParams(el.dataset.year);
        } else {
          el.dataset.state = 'close';

          // URLからパラメータを削除
          self.removeUrlParams();
        }
      });
    });

    const tab_select_el = this.el.querySelectorAll(['[data-el="tab-select"]']);
    tab_select_el.forEach(function (el) {
      el.addEventListener('change', function (e) {
        const year = e.target.value;
        if (year) {
          self.el
            .querySelectorAll(['[data-state="open"]'])
            .forEach(function (el) {
              el.dataset.state = 'close';
            });
          self.el
            .querySelectorAll(['[data-year="' + year + '"]'])
            .forEach(function (el) {
              el.dataset.state = 'open';
            });

          // URLパラメータを更新
          self.updateUrlParams(year);
        } else {
          // URLからパラメータを削除
          self.removeUrlParams();
        }
      });
    });
  }

  /**
   * URLパラメータから年度を取得して初期表示を設定
   */
  initFromUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const year = urlParams.get('y'); // yearからyに変更
    const hash = window.location.hash.substring(1); // アンカーリンク対応

    if (year) {
      // 対応する年度のタブを開く
      this.el.querySelectorAll(['[data-state="open"]']).forEach((el) => {
        el.dataset.state = 'close';
      });

      // タブとコンテンツを開く
      this.el.querySelectorAll(['[data-year="' + year + '"]']).forEach((el) => {
        el.dataset.state = 'open';
      });

      // セレクトボックスも更新
      const selectEl = this.el.querySelector('[data-el="tab-select"]');
      if (selectEl) {
        // 年度が2020以下の場合は、セレクトボックスの値を設定
        // それ以外の場合は、初期値の「以前の資料」（空の値）を維持
        if (parseInt(year) <= 2020) {
          selectEl.value = year;
        }
      }
    }
  }

  /**
   * URLパラメータを更新
   * @param {string} year - 選択された年度
   */
  updateUrlParams(year) {
    if (!year) return;

    const url = new URL(window.location);
    url.searchParams.set('y', year); // yearからyに変更

    // タブ押下時にはアンカーリンクを削除
    // URLを更新（履歴に追加せずに現在のURLを置き換え）
    // アンカーを確実に削除するため、origin + pathname + search の形式でURLを構築
    const newUrl = url.origin + url.pathname + url.search;
    window.history.replaceState({}, '', newUrl);
  }

  /**
   * URLからパラメータを削除
   */
  removeUrlParams() {
    const url = new URL(window.location);
    url.searchParams.delete('y'); // yearからyに変更

    // アンカーリンクを保持
    // URLを更新（履歴に追加せずに現在のURLを置き換え）
    window.history.replaceState({}, '', url.toString() + hash);
  }
}
